import moment from "moment";
import store from "../redux/store";
import authState from "../redux/actions/auth";
import quiz from "../redux/actions/quiz";
import { orgDetails } from "../org";

var selectedAnswers = [];

var progess = 0;

function calculateElapsedTime(remainingTime, state) {
  if (state?.config?.Time_Mins) {
    let totalSeconds = state?.config?.Time_Mins * 60;
    return remainingTime < totalSeconds ? totalSeconds - remainingTime : totalSeconds - 1;
  }
  return 0;
}

function removeAnswers() {
  selectedAnswers = [];
  localStorage.removeItem("selectedAnswers");
}

function insertAnswer(ansObj, total) {
  if (ansObj && total) {
    selectedAnswers.push(ansObj);
    if (selectedAnswers.length === 0 && localStorage.selectedAnswer) {
      selectedAnswers = localStorage.selectedAnswers && JSON.parse(localStorage.selectedAnswers);
    }
    if (selectedAnswers) {
      selectedAnswers = getUnique(selectedAnswers, "questionID");
    }
    if (selectedAnswers.length !== 0) {
      selectedAnswers = selectedAnswers.filter((obj) => {
        return obj && obj.answer && obj.answer.length !== 0;
      });
      localStorage.selectedAnswers = selectedAnswers;
    }

    if (selectedAnswers) {
      progess = (100 * selectedAnswers.length) / total;
      progess = Math.round(progess);
      // console.log("progess", progess);  // FK cleanup console july 2023
    }
  }
}

function getUnique(arr, comp) {
  const unique = arr
    .map((e) => e[comp])

    .map((e, i, final) => final.lastIndexOf(e) === i && i)

    .filter((e) => arr[e])
    .map((e) => arr[e]);

  return unique;
}

function getObject(key, value, array) {
  let obj = null;
  if (array) {
    obj = array.find((item) => {
      return item[key] === value;
    });
  }
  return obj;
}

function getObjectThatContains(key, value, array) {
  let obj = null;
  if (array) {
    obj = array.find((item) => {
      return item[key].includes(value);
    });
  }
  return obj;
}

function getIdx(key, value, array) {
  if (array) {
    var ln = array.length;
    for (var i = 0; i < ln; i++) {
      if (array[i][key] === value) {
        return i;
      }
    }
  }
  return -1;
}

function saveQuestionWiseAnswers(questionId, answers) {
  // console.log('saveQuestionWiseAnswers: ', questionId, answers); // FK cleanup console july 2023
}

const ImagebaseUrl = "https://d2po7vz9ilj7b0.cloudfront.net/";

function TimeZonePT(datevalue) {
  const date = moment(datevalue);
  // const pst = date.toLocaleString('en-US', {
  //   timeZone: 'America/Los_Angeles',
  //   month: 'short',
  //   day: '2-digit',
  //   hour: '2-digit',
  //   minute: '2-digit',

  // });
  // return pst
  return date.format("MMM D, HH:mm a zz");
}

function getTestExpiryDate(date, daysFromNow) {
  let then = moment(date).add(daysFromNow, "days").hours(11).minutes(59).seconds(59).milliseconds(0);
  return then;
}

//sets the optional value for a field
function setOptValue(val) {
  if (!val || val.length === "") {
    return "None";
  } else {
    return val;
  }
}

/**
 * Sort Json Object
 * @param {*} json
 * @param {*} order
 * @param {*} key
 * @returns
 */
const sortJson = (json, order, key, fieldType = "") => {
  if (order.toLowerCase() === "asc") {
    return json.sort((a, b) => {
      if (fieldType === "date") {
        return (
          Object.hasOwn(a, key) &&
          Object.hasOwn(b, key) &&
          moment(a[key]).format("YYYYMMDD") - moment(b[key]).format("YYYYMMDD")
        );
      }

      if (fieldType === "tuple") {
        let aVal = a[key][1] === 0 ? 0 : a[key][0] / a[key][1];
        let bVal = b[key][1] === 0 ? 0 : b[key][0] / b[key][1];

        if (aVal > bVal) {
          return 1;
        }
        if (aVal < bVal) {
          return -1;
        }
        if (a[key][1] > b[key][1]) {
          return 1;
        }
        return -1;
      }

      if (Number.isInteger(parseInt(a[key]))) {
        return Object.hasOwn(a, key) && Object.hasOwn(b, key) && a[key] - b[key];
      }
      return Object.hasOwn(a, key) && Object.hasOwn(b, key) && a[key].toString().localeCompare(b[key].toString());
    });
  }

  return json.sort((a, b) => {
    if (fieldType === "date") {
      return (
        Object.hasOwn(a, key) &&
        Object.hasOwn(b, key) &&
        moment(b[key]).format("YYYYMMDD") - moment(a[key]).format("YYYYMMDD")
      );
    }

    if (fieldType === "tuple") {
      let aVal = a[key][1] === 0 ? 0 : a[key][0] / a[key][1];
      let bVal = b[key][1] === 0 ? 0 : b[key][0] / b[key][1];

      if (aVal > bVal) {
        return -1;
      }
      if (aVal < bVal) {
        return 1;
      }
      if (a[key][1] > b[key][1]) {
        return -1;
      }
      return 1;
    }

    if (Number.isInteger(parseInt(a[key]))) {
      return Object.hasOwn(a, key) && Object.hasOwn(b, key) && b[key] - a[key];
    }
    return Object.hasOwn(a, key) && Object.hasOwn(b, key) && b[key].toString().localeCompare(a[key].toString());
  });
}; //End

// search for a set of words in an object.
function searchObj(obj, words, searchKeys) {
  // Extract visible keys only
  let objVisibleKeys = {};

  for (let key of searchKeys) {
    objVisibleKeys[key] = obj[key];
  }

  const valString = Object.values(objVisibleKeys).join().toLowerCase();

  return words.map((word) => valString.includes(word)).reduce((i, j) => i && j);
}

//apply search string on a set of data
function applySearch(data, searchString, searchKeys) {
  searchString = searchString.replace(/,/g, "");
  // searchString = searchString.replace(/  +/g, ' ').trim();

  const searchWords = searchString.toLowerCase().split(/\s+/);
  return data?.filter((item) => searchObj(item, searchWords, searchKeys));
}

function logout() {
  store.dispatch(authState.clearState());
  localStorage.removeItem("token1");
  localStorage.removeItem("userid");
  localStorage.removeItem("user_details");
  localStorage.removeItem("uid");
  store.dispatch(quiz.clearState());
  // window.location.href = "/"
}

function getDomainDetails(url) {
  let domainName = new URL(url);
  domainName = domainName.hostname.replace("www.", "");
  domainName = domainName.split(".")[0];
  domainName = domainName.trim().toLowerCase();
  // console.log(Object.hasOwn(orgDetails,domainName))

  if (
    domainName === "" ||
    !Object.hasOwn(orgDetails, domainName) ||
    domainName === "yourtechscore" ||
    domainName === "localhost"
  ) {
    return orgDetails["default"];
  } else {
    return orgDetails[domainName];
  }
}

// Display coding languages for invite jobrole
function codingLanguageDisplay(languages) {
  let langs = [...languages];
  langs = langs.sort();

  langs = langs.splice(0, 3);

  let visibleCnt = 0;
  let str = "";

  for (let i in langs) {
    str += langs[i];
    if (str.length <= 15) {
      if (i == langs.length - 1) {
        visibleCnt = +i + 1;
        break;
      }
      continue;
    } else {
      visibleCnt = +i;
      break;
    }
  }

  if (languages.length === 1 && visibleCnt === 1) {
    return langs.splice(0, visibleCnt).toString();
  }

  return languages.length === visibleCnt
    ? langs.splice(0, visibleCnt).join(" / ")
    : langs.splice(0, visibleCnt).join(" / ") + " ...";
}

function expand_timeline(orig_timeline, mode = false, type = "L2") {
  if (orig_timeline) {
    let new_timeline = [];
    // let threshold = 0;
    // switch (type) {
    //   case "coding":
    //     threshold = 40;
    //     break;
    //   case "technical":
    //     threshold = 20;
    //     break;
    //   case "presentation":
    //     threshold = 10;
    //     break;
    //   default:
    //     threshold = 20;
    // }
    const threshold = Math.ceil(
      (orig_timeline[orig_timeline.length - 1].startTime - orig_timeline[0].startTime) / 30.0
    );
    let delta = 0;
    let prev = orig_timeline[0];
    let curr;
    prev["pseudoStartTime"] = prev.startTime;
    new_timeline.push(prev);
    for (let i = 1; i < orig_timeline.length; i++) {
      curr = orig_timeline[i];
      if (!mode) {
        curr["pseudoStartTime"] = curr.startTime;
      } else {
        if (curr.startTime - prev.startTime < threshold) {
          delta += threshold;
        }
        curr["pseudoStartTime"] = curr.startTime + delta;
      }
      new_timeline.push(curr);
      prev = curr;
    }
    const old_len = new_timeline[new_timeline.length - 1].startTime - new_timeline[0].startTime;
    const new_len = new_timeline[new_timeline.length - 1].pseudoStartTime - new_timeline[0].pseudoStartTime;
    const scale_factor = new_len / old_len;
    // console.log("func logs", old_len, new_len, scale_factor);

    return { newTimeline: new_timeline, scaleFactor: scale_factor };
  } else {
    return { newTimeline: [], scaleFactor: 1 };
  }
}

/**
 * Escapes HTML special characters in a string.
 * @param {string} html - The HTML string to escape.
 * @returns {string} - The escaped HTML string.
 */
function escapeHTML(html) {
  return html
    ?.replace(/&/g, "&amp;")
    ?.replace(/</g, "&lt;")
    ?.replace(/>/g, "&gt;")
    ?.replace(/"/g, "&quot;")
    ?.replace(/'/g, "&#039;");
}

/**
 * Replaces custom image syntax with HTML <img> tags.
 * @param {string} text - The text containing custom image syntax.
 * @returns {string} - The text with image syntax replaced by HTML <img> tags.
 */
function replaceImageSyntaxWithHTML(text) {
  return text?.replace(
    /!\[image\]\((.*?)\)/g,
    '<img style="padding:10px;background:#fff;" src="https://yts-org-assets.s3.amazonaws.com/question-images/$1" alt="Image">'
  );
}

/**
 * Replaces inline code blocks with HTML <code> tags.
 * @param {string} string - The string containing inline code blocks.
 * @returns {string} - The string with inline code blocks replaced by HTML <code> tags.
 */
function replaceInlineCodeBlockWithHTML(string) {
  return string?.replace(/`([^`]+)`/g, "<code style='padding: 0 5px'>$1</code>");
}

/**
 * Transforms a text string with custom syntax into HTML.
 * @param {string} text - The text to transform.
 * @returns {string} - The transformed HTML string.
 */
export const transformToHTML = (text) => {
  // Split the text into segments that are either within code blocks or not
  // let htmlContent = text.split(/(```code_start|```code_end)/g);
  let htmlContent = text?.split(/(```code_start.*?\n|```code_end)/g);
  // console.log(text.split(/(```code_start|```code_end)/g));
  // console.log(htmlContent.length);

  if (htmlContent?.length > 1) {
    // Process each segment
    for (let i = 0; i < htmlContent?.length; i++) {
      // console.log(htmlContent[i]);
      if (htmlContent[i].startsWith("```code_start")) {
        // Extract the language from the code_start delimiter
        let languageMatch = htmlContent[i].match(/```code_start_([a-zA-Z0-9_]+)/);
        let languageClass = languageMatch ? `class="language-${languageMatch[1]}"` : "";

        htmlContent[i] = `<pre class='line-numbers' style='margin: 0;background: #f6f6f6;border-radius: 5px; ${
          languageClass === "" ? "padding:12px 10px;margin-top: 15px;" : ""
        } '><code ${languageClass}>`;
        htmlContent[i + 1] = escapeHTML(htmlContent[i + 1].trim());
        if (htmlContent[i + 2] !== "```code_end") {
          htmlContent[i + 1] =
            htmlContent[i + 1] +
            "</code></pre><p><span style='padding:2px 5px; border: solid 1px #ff6b6b;background: #ffebeb;color: #ff6b6b;'>ERROR in closing Code Block. Check question text</span></p>";
          i += 1;
        } else {
          htmlContent[i + 2] = "</code></pre>";
          i += 2;
        }
      } else {
        htmlContent[i] = escapeHTML(htmlContent[i]);
        htmlContent[i] = replaceInlineCodeBlockWithHTML(htmlContent[i]);
        htmlContent[i] = htmlContent[i]?.replace(/\n/g, "<br>");
        htmlContent[i] = replaceImageSyntaxWithHTML(htmlContent[i]);
      }
    }

    // Join the processed segments back together
    htmlContent = htmlContent.join("");
  } else {
    htmlContent = escapeHTML(text);
    htmlContent = replaceInlineCodeBlockWithHTML(htmlContent);
    htmlContent = htmlContent?.replace(/\n/g, "<br>");
    htmlContent = replaceImageSyntaxWithHTML(htmlContent);
  }

  // Return the transformed HTML content
  return htmlContent;
};

export {
  setOptValue,
  getTestExpiryDate,
  removeAnswers,
  insertAnswer,
  progess,
  getObjectThatContains,
  getUnique,
  getObject,
  getIdx,
  saveQuestionWiseAnswers,
  calculateElapsedTime,
  TimeZonePT,
  ImagebaseUrl,
  sortJson,
  applySearch,
  logout,
  getDomainDetails,
  codingLanguageDisplay,
  expand_timeline,
};
